import { render, staticRenderFns } from "./RegisterInfo.vue?vue&type=template&id=6906ff8e&scoped=true"
import script from "./RegisterInfo.vue?vue&type=script&lang=js"
export * from "./RegisterInfo.vue?vue&type=script&lang=js"
import style0 from "./RegisterInfo.vue?vue&type=style&index=0&id=6906ff8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6906ff8e",
  null
  
)

export default component.exports